import { Header } from "./common/Header";
import { Link } from "react-router-dom";
import { Icons } from "./utils/Icons";
import { Footer } from "./common/Footer";
import arrowBackIcon from "./assets/img/arrowBack.svg";

export default function Politicas() {
  return (
    <div className="appContainer" style={{backgroundColor: "#FFF"}}>
      <div className="mainHeader">
        <Header />
      </div>
      <main className="legalDocument mainWidth">
        <Link to="/" className="smallButton">
          <Icons path={arrowBackIcon} />
          Volver
        </Link>
        <div className="container">
          <h1>Políticas de privacidad</h1>
          <h2>Reglas generales y definiciones</h2>
          <ol>
            <ol>
              <li>
                <p>
                  Si usted elige usar la red de sitios de Red Televisiva
                  Megavisión S.A., sus sitios móviles, sus aplicaciones y/o
                  cualquiera de las opciones de los sitios [en adelante, todos
                  ellos los <i>“Servicios”</i>], usted declara conocer y aceptar
                  todos los términos y condiciones de estos términos de los
                  Servicios [en adelante, <i>“Términos de Servicios”</i>] entre
                  usted y Red Televisiva Megavisión [en adelante,
                  indistintamente,
                  <i>“Mega” o “Nosotros”</i>].
                </p>
              </li>
              <li>
                <p>
                  Nosotros podremos cambiar, agregar o remover parte de estos
                  Términos de Servicios en cualquier momento, lo cual será
                  publicado inmediatamente. Será de su responsabilidad revisar
                  estos Términos de Servicio previo a cada uso de los Servicios
                  y durante el continuo uso de los Servicios por parte de Ud.,
                  quien acepta, en forma expresa, estos cambios por el solo
                  hecho de hacer uso de los Servicios.
                </p>
              </li>
              <li>
                <p>
                  En efecto, si cualquiera de estas reglas o futuros cambios son
                  inaceptables para usted, usted deberá cancelar su suscripción
                  enviando un email a comunicaciones@mega.cl
                  (Ver sección 10.1 relacionado con el término de los
                  servicios). Su continuación con el uso de los servicios ahora
                  o en las siguientes publicaciones de cualquier cambio en las
                  reglas, significa su aceptación explicita de estas reglas, sus
                  cambios y modificaciones.
                </p>
              </li>
              <li>
                <p>
                  Nosotros podremos cambiar, suspender o discontinuar algún
                  aspecto de los Servicios en cualquier momento, incluyendo la
                  disponibilidad de cualquier opción dentro de los Servicios.
                </p>
              </li>
            </ol>
          </ol>
          <ol>
            <li>
              <h4>CONTENIDO DE LOS SERVICIOS</h4>
              <ol>
                <li>
                  <p>
                    Los Servicios y su contenido sólo podrá ser usado para uso
                    personal y jamás comercial o para otra finalidad. Todo el
                    material publicado en los Servicios (Incluyendo, pero no
                    limitado, a nuevos artículos, fotografías, imágenes,
                    ilustraciones, clips de audio y video, etc. [en adelante,
                    también, el <i>“Contenido”</i>], son protegidos por
                    Copyright o propiedad intelectual y derechos de autor [en
                    adelante, también, <i>“Copyright”</i>], todos los cuales son
                    de titularidad, propiedad y control de MEGA o de sus partes
                    acreditadas. Usted deberá cumplir con todas las exigencias o
                    restricciones de Copyright al acceder al Contenido.
                  </p>
                </li>
                <li>
                  <p>
                    Los Servicios y el Contenido son protegidos por Copyright
                    conforme las leyes Chilenas. Usted no podrá modificar,
                    publicar, transmitir, vender, reproducir (a excepción de lo
                    mencionado en la sección 2.3 de estos Términos de
                    Servicios), crear nuevos trabajo a partir de este Contenido,
                    distribuir, ejecutar, mostrar, o explotar de alguna manera
                    el Contenido de estos servicios (Incluidos Software) de
                    manera completa o en parte ni menos atribuirse o pretender
                    algún tipo de propiedad o titularidad sobre el mismo2.3
                    Usted podrá descargar o copiar el Contenido y otros
                    contenidos descargables en
                  </p>
                  <p>
                    los Servicios para uso personal solamente, considerando que
                    usted mantendrá y respectará, en forma irrestricta, los
                    derechos de Copyright. Copiar o almacenar el Contenido para
                    otro uso que no sea personal está expresamente prohibido.
                  </p>
                  <p>
                    2.4 El Contenido de los Servicios es propiedad o licencia de
                    Red Televisiva Megavisión S.A.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <h4>
                USUARIO GENERADOR DE CONTENIDO: CONTENIDO GENERADO A PARTIR DE
                COMENTARIOS, REVISIONES Y MÁS.
              </h4>
              <ol>
                <li>
                  <p>
                    Usted no podrá subir, distribuir o publicar en los Servicios
                    algún material difamatorio, obsceno, pornográfico, abusivo o
                    ilegal.
                  </p>
                  <p>
                    Sea Cortés. Usted accede y se obliga a que no tratará de
                    manera amenazadora o con un lenguaje abusivo a otros
                    miembros o personas, no usará lenguaje difamatorio, no
                    interrumpirá discusiones con mensajes repetitivos, sin
                    sentido o “Spam”.
                  </p>
                  <p>
                    Use un lenguaje respetuoso. Como cualquier comunidad la
                    conversación online florece cuando se está en un ambiente de
                    bienvenida y seguridad. Usted accede y se obliga a no usar
                    lenguaje abusivo ni discriminatorio por motivos de raza,
                    religión, nacionalidad, genero, preferencias sexuales, edad,
                    región, discapacidad, etc. El incumplimiento de esta
                    obligación es causa justificada y suficiente para la
                    suspensión inmediata y permanente al acceso de los
                    Servicios.
                  </p>
                  <p>
                    Discuta pero no ataque. En una comunidad con diversas
                    opiniones y preferencias, la gente puede no estar de
                    acuerdo. MEGA alienta las discusiones activas, respetuosas,
                    sanas y da la bienvenida a discusiones acaloradas en sus
                    Servicios, pero los ataques personales, abusivos o el
                    lenguaje obsceno, descalificatorio o discriminatorio,
                    constituyen una violación de las obligaciones señaladas y de
                    los Términos de los Servicios y autoriza a MEGA para poner
                    término, en forma inmediata, a los mismos.
                  </p>
                </li>
                <li>
                  <p>
                    Como ya se ha indicado, los Servicios sólo pueden ser usados
                    para fines no comerciales y sólo personales. Usted no
                    deberá, sin el consentimiento explícito de MEGA, distribuir
                    o publicar algún material o Contenido ni menos solicitando
                    fondos, promocionando o solicitando productos o servicios.
                  </p>
                </li>
                <li>
                  <p>
                    Usted debe estar en conocimiento que cualquier material
                    compartido en los Servicios (por ejemplo: generación de
                    contenido incluyendo, pero no limitado a, comentarios,
                    fórum, mensajes, revisiones, texto, video, audio o
                    fotografía, así como códigos de computación y aplicaciones)
                    puede ser editado, removido, modificado, publicado,
                    transmitido y mostrado en y por MEGA y usted, en este acto y
                    por el solo hecho de hacer uso de los Servicios, así lo
                    autoriza y entrega cualquier derecho para mantener el
                    material alterado o cambiado. Incluye también material
                    compartido en RRSS feeds y aplicaciones. Todos los cuales
                    estarán disponibles para ser republicados en cualquier otro
                    formato que MEGA determine.
                  </p>
                </li>
                <li>
                  <p>
                    Usted entrega a MEGA la licencia del material compartido, el
                    cual será una licencia perpetua, no exclusiva, en todo el
                    mundo, con royalty gratuito o libre de cualquier pago,
                    compensación o retribución alguna, de cualquier especie,
                    tipo o naturaleza, sub licenciable, lo que incluye sin
                    limitación los derechos para MEGA o algún otro designado por
                    ésta para usar, copiar, transmitir, publicar, distribuir,
                    publicitar, mostrar, crear derivados del Contenido,
                    almacenar, etiquetar, adaptar, modificar (incluyendo sin
                    limitación el derecho de adaptar el material a streaming,
                    descargar, broadcast, móvil, digital, thumbnail, escanear u
                    otras tecnologías) en cualquier tecnología conocida hoy y
                    por desarrollar.
                  </p>
                </li>
                <li>
                  <p>
                    Usted es el único responsable por el contenido compartido.
                    MEGA NO será responsable por su contenido en forma alguna.
                    En todo caso, MEGA se reserva el derecho de borrar, mover o
                    editar el material que tenga contenido abusivo, difamatorio,
                    obsceno o que no sea aceptable por leyes de Copyright y/o
                    según los propios Contenidos Editoriales de MEGA.
                  </p>
                </li>
                <li>
                  <p>
                    Al compartir en los Servicios material o contenidos, usted
                    da su consentimiento para que sea mostrado y publicado en
                    los Servicios y en cualquier otra platafoma, formato o
                    servicios que MEGA determine y que puedan ser promocionados
                    online u offline.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <h4>USO DE LOS SERVICIOS</h4>
              <ol>
                <li>
                  <p>
                    Usted no puede acceder o usar, o intentar usar o acceder a
                    los Servicios para tomar acciones que puedan dañar a MEGA o
                    a sus terceras partes o partes relacionadas. Usted no puede
                    acceder a partes de los Servicios que no estén autorizados.
                    Usted no deberá ni intentará evitar cualquier restricción o
                    condición impuesta en su uso o acceso a los Servicios, o
                    hacer cualquier cosa que pueda desarmar o dañar la
                    funcionalidad de los Servicios, incluyendo la presentación
                    de los anuncios. Estar expuestos a anuncios publicitarios es
                    una condición de acesibilidad a los Servicios.
                  </p>
                </li>
                <li>
                  <p>
                    Los Servicios contienen links para otros sitios relacionados
                    a nivel mundial, recursos y publicidad. Considerando que
                    MEGA no es responsable por la disponibilidad de estos
                    recursos fuera de los servicios de MEGA o su contenido,
                    cualquier problema lo debe derivar directamente a la fuente
                    de dichos sitios.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <h4>REPRESENTANTES Y GARANTÍAS</h4>
              <ol>
                <li>
                  <p>
                    Usted representa, garantiza y pacta que ningún material de
                    ningún tipo presentado a través de su cuenta (i) violará,
                    plagiará o infringirá lo derechos de terceros, incluyendo
                    derechos de autor, de marca, privacidad u otros derechos
                    personales o de propiedad; o (ii) contendrá material
                    difamatorio o desleal; y (b) que tienes al menos catorce
                    años de edad. Asimismo, por el presente usted se obliga a
                    mantener indemne, sin daño y a indemnizar y defender a MEGA
                    y a todos los oficiales, directores, gerentes, ejecutivos,
                    abogados, dueños, agentes, proveedores de información,
                    afiliados, licenciadores y licenciados (colectivamente, los
                    “Partes Indemnizadas”) provenientes y en contra todas u
                    cualquier responsabilidad y costos, incluyendo, sin
                    limitación, cargos razonables por abogados, incurridos por
                    las Partes Indemnizadas en conexión con cualquier reclamo
                    surgido por cualquier traspaso por parte de usted o por
                    cualquier usuario de su cuenta de estos Términos de Servicio
                    o de las representaciones con precedentes, garantías y
                    pactos. Usted deberá cooperar siempre que sea razonable en
                    la defensa de los reclamos pertinentes. MEGA se reserva el
                    derecho, a asumir la exclusiva defensa y control de
                    cualquier materia sujeta a identificaciones hechas por
                    usted.
                  </p>
                </li>
                <li>
                  <p>
                    MEGA no representa o endosa la certeza o confiabilidad de
                    cualquier dispositivo, opinión, declaración, o cualquier
                    otra información expuesta, subida, o distribuida a través de
                    los Servicios de cualquier usuario, proveedor de información
                    o cualquier otra persona o entidad. Usted reconoce que
                    cualquier dependencia sobre una opinión, consejo,
                    declaración, memorándum, o información será bajo su propio
                    riesgo. Los servicios y todos los software descargables son
                    distribuidos en una base de “Como es” o “En la condición o
                    estado en que se encuentran disponibles”, sin garantías de
                    ningún tipo, ni explicitas ni implícitas, incluyendo, sin
                    limitación, garantías de título para propósitos
                    particulares. Por el presente usted reconoce el uso los
                    servicios y de su contenido bajo su propio riesgo.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <h4>REGISTRO Y SEGURIDAD</h4>
              <ol>
                <li>
                  <p>
                    Como parte del proceso de creación de cuenta, usted creará
                    las credenciales de registro seleccionando una contraseña y
                    una dirección de correo electrónico. También, se debe
                    entregar cierta información de registro, toda la cual debe
                    ser correcta y actualizada.
                  </p>
                  <p>
                    Cada registro es sólo para un único usuario. Usted no tiene
                    permitido compartir sus credenciales de registro o dar sus
                    contraseñas a alguien más. MEGA podrá poner término o
                    suspender su acceso a los Servicios si esas credenciales son
                    compartidas. Usted es responsable de mantener bajo
                    confidencialidad y reserva su contraseña, la cual no deberá
                    ser entregada a ningún agente o representante de MEGA. No
                    deberás (i) seleccionar o usar la credencial de registro de
                    otra persona con el intento de personificarla; (ii) usar las
                    credenciales de registro de una persona que tiene derechos
                    sobre esos registros sin autorización de esa persona; o
                    (iii) usar credenciales de registro, que, a nuestra
                    discreción, resultan ser ofensivas. Cualquier incumplimiento
                    de las acciones anteriormente expuestas será una vulneración
                    a los Términos de Servicio, lo cual puede resultar en la
                    suspensión inmediata y terminación de la cuenta.
                  </p>
                </li>
                <li>
                  <p>
                    Por favor notificar a
                    <a href="mailto:comunicaciones@mega.cl">
                      comunicaciones@mega.cl
                    </a>
                    si sabe o sospecha del uso sin autorización de su cuenta, o
                    cualquier conocimiento o sospecha de una vulneración de
                    seguridad, incluyendo pérdida, robo, o revelación no
                    autorizada de su contraseña o información de tarjeta de
                    crédito.
                  </p>
                </li>
                <li>
                  <p>
                    Usted debe tener al menos catorce años para suscribirse a
                    los Servicios.
                  </p>
                </li>
                <li>
                  <p>
                    Usted es responsable por todas las actividades o uso en su
                    cuenta de www.mega.cl, incluyendo el uso de su cuenta por
                    parte de terceros autorizados para usar sus credenciales de
                    registro. Cualquier actividad fraudulenta, abusiva, o ilegal
                    será justificación suficiente para la terminación de su
                    cuenta, bajo nuestra discreción, y podremos referirlo con
                    las agencias de cumplimiento de ley apropiadas.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <h4>MATRICULAS Y PAGOS</h4>
              <p>
                7.1. MEGA se reserva el derecho a cobrar matriculas de acceso a
                porciones de los Servicios o por los Servicios en su totalidad
                en cualquier momento. Sin embargo, bajo ninguna circunstancia se
                cobrará el acceso a los Servicios sin previo acuerdo mutuo a
                pagar por esos Servicios. Así, si en cualquier momento
                requerimos un pago por alguna porción de los Servicios que hasta
                el momento eran gratuitos, les informaremos y notificaremos con
                anticipación sobre futuros cargos y pagos por los Servicios.
                Usted podrá cancelar su cuenta en cualquier momento. Todos los
                nuevos cargos por Servicios, de haber alguno, serán publicados
                oportunamente en los Servicios y en otras ubicaciones de los
                Servicios. Usted deberá pagar todos los cargos y matriculas
                incurridos en su cuenta a las tarifas efectuadas en el periodo
                de facturación en el que esos cargos y matricula fueron
                generados, incluyendo, pero no limitados a los cargos por
                Servicios o productos digitales ofrecidos a la venta a través de
                estos Servicios por MEGA o por cualquier otro vendedor o
                proveedor de servicios. Todos los pagos y matriculas deberán ser
                facturados y pagados por usted. Se deberá pagar con todos los
                impuestos correspondientes y relacionados con los servicios
                utilizados en su cuenta.
              </p>
            </li>
            <li>
              <h4>
                COMUNICACIÓN ENTRE RED TELEVISIVA MEGAVISIÓN Y LOS USUARIOS
              </h4>
              <ol>
                <li>
                  <p>
                    Si usted indica en su registro que desea recibir
                    información, nosotros, nuestros dueños y asignados,
                    permitiremos que determinados terceros vendedores puedan
                    proveerle información acerca productos y servicios.
                  </p>
                </li>
                <li>
                  <p>
                    MEGA se reserva el derecho a enviar correos electrónicos a
                    usted con el propósito de informar cambios o adiciones a los
                    Servicios.
                  </p>
                </li>
                <li>
                  <p>
                    MEGA podrá contactarlo a través de un correo electrónico con
                    respecto a su participación en encuestas, requiriendo
                    retroalimentación en cuanto a determinados servicios o
                    prospectos de productos y servicios. Esta información será
                    utilizada para mejorar los servicios y comprender de mejor
                    manera a nuestros usuarios, y toda la información que
                    obtengamos en dichas encuestas no será compartida con
                    terceros, excepto de forma agregada.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <h4>TERMINACIÓN</h4>
              <ol>
                <li>
                  <p>
                    Usted podrá cerrar su cuenta en cualquier momento
                    enviándonos un correo electrónico a
                    <a href="mailto:comunicaciones@mega.cl">
                      comunicaciones@mega.cl
                    </a>
                    con el asunto “CANCELACIÓN”. En cuanto se haya cerrado,
                    recibirá un correo electrónico automático de confirmación en
                    donde se expresará que se la cancelación de su cuenta está
                    siendo procesada, y su acceso será suspendido dentro de las
                    siguientes 24 horas.
                  </p>
                </li>
                <li>
                  <p>
                    MEGA podrá, bajo su discreción, terminar o suspender su
                    acceso al cualquier tipo de los Servicios, sea cual sea la
                    razón, incluyendo, sin limitación, la asignación o
                    vulneración de estos Términos de Servicios.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <h4>MISCELANEO</h4>
              <ol>
                <li>
                  <p>
                    Estos Términos de Servicios han sido creados, construidos y
                    regulados de acuerdo a las leyes Chilenas. Cualquier acción
                    para hacer cumplir estos Términos de Servicios deberán ser
                    llevados ante los tribunales ordinarios de justicia
                    domiciliados en la ciudad y comuna de Santiago.
                  </p>
                </li>
                <li>
                  <p>
                    Toda la correspondencia deberá ser enviada a
                    <a href="mailto:comunicaciones@mega.cl">
                      comunicaciones@mega.cl.
                    </a>
                  </p>
                </li>
                <li>
                  <p>
                    Usted está de acuerdo en reportar cualquier tipo de
                    violación a los derechos de Copyright y a los Términos de
                    Servicios de MEGA en cuanto esté consciente de que están
                    ocurriendo. Así como cualquier reclamo relacionado.
                  </p>
                </li>
              </ol>
            </li>
          </ol>
          <h2>¿QUE INFORMACION RECOLECTAMOS DE USTED?</h2>
          <p>
            La información recolectada cuando se interactúa con los Servicios de
            MEGA recae en dos categorías: 1) Información personal, que incluye
            la proporcionada al momento de la suscripción, al momento de ordenar
            productos, completar encuestas, registrarse en uno de nuestros
            sitios, participar en un sorteo o proporcionando su correo
            electrónico y 2) Información No-personal colectada a través de la
            tecnología, que incluye información de rastreo colectada por
            nosotros como también terceros.
          </p>
          <p>
            Información personal que nos entrega o pide a terceros que compartan
            con nosotros
          </p>
          <h3>Información de registro</h3>
          <p>
            El registro para los Servicios de MEGA puede requerir que se
            entregue cierta información personal, incluyendo una dirección de
            correo personal e información demográfica (código postal, edad,
            sexo, ingreso familiar, industria en la que trabaja y título) para
            ser registrado.
          </p>
          <h3>Información de Facturación y Tarjeta de Crédito</h3>
          <p>
            Para habilitar los pagos y donaciones vía los Servicios de MEGA,
            colectamos y almacenamos nombre, dirección, número de teléfono,
            dirección de correo electrónico, información de tarjeta de crédito y
            otra información de facturación. Esta información será solo
            compartida con terceros que ayuden a completar la transacción de
            compra. Un ejemplo de esto incluye el llenado de órdenes y el
            procedimiento de los pagos con tarjetas de crédito.
          </p>
          <h3>
            Contenido generado por los usuarios y actividades públicas
            (incluyendo comentarios y comentarios de lectores)
          </h3>
          <p>
            Podrían ser incluidas actividades públicas en nuestra red de RRSS,
            API's y otros formatos de distribución. Como resultado, sus
            actividades públicas podrán aparecer en otros sitios web, blogs, o
            feeds. Tenga en cuenta que no nos responsabilizamos por la
            información privada que publica a través de sus actividades
            públicas, y estará de acuerdo en que ese tipo de actividades será
            comprendido en que fue ejecutada por usted y no por MEGA.
          </p>
          <p>
            Cuando comparta o recomiende links en una plataforma de terceros
            (como Facebook, Google+ y Twitter), ese tipo de acciones serán
            cubiertas por sus políticas de privacidad.
          </p>
          <h3>Concursos, liquidaciones y ofertas especiales.</h3>
          <p>
            MEGA colecta información cuando se participa en liquidaciones,
            concursos y ofertas especiales. Si esta información, también, está
            siendo colectada por terceros, se lo notificaremos. Si usted desea
            no compartir su información personal, no debiese participar en
            liquidaciones, concursos y ofertas especiales. Si lo hace, se obliga
            a compartir dicha información.
          </p>
          <h3>
            Encuestas a lectores, paneles de lectura e investigación de mercado
          </h3>
          <p>
            MEGA podrá colectar información de usted en conexión con encuestas
            voluntarias conducidas por los Servicios de MEGA. Esta información
            podrá ser colectada por los servicios de MEGA a través de teléfono o
            correo electrónico. La información que se proporciona podrá ser
            compartida, solo en ese contexto, con anunciantes y partners, a
            menos que notifiquemos lo contrario al momento de la colección.
          </p>
          <h3>Conferencias y Eventos en vivo</h3>
          <p>
            A menudo recibimos información de los invitados a nuestros eventos
            en vivo de las listas de registros de Log-in. Podremos compartir
            esta información con patrocinadores de eventos, en ese caso le
            notificaremos que colectaremos dicha información.
          </p>
          <p>Información no-personal colectada usando tecnología</p>
          <h3>Información colectada con nosotros usando tecnología</h3>
          <p>
            Nosotros utilizamos diversas tecnologías para manejar los servicios
            de MEGA y hacer seguimiento de los Servicios. La información
            no-personal que sea colectada utilizando estas tecnologías podrá ser
            combinada con otra información de usted.
          </p>
          <p>
            <b>Información del dispositivo.</b> Podremos colectar información
            no-personal correspondiente a el computador, dispositivo móvil, u
            otro dispositivo que se utilice para acceder a los servicios de
            MEGA, tales como direcciones de IP, información de geolocalización,
            identificadores de dispositivos únicos, tipo de navegador, leguaje
            de navegador, y otra información de transacción.
          </p>
          <h3>
            Cookies, Beacons, Almacenamiento Local y otras tecnologías
            similares.</h3><p> Utilizamos “cookies”, Web Beacons, etiquetas y scripts,
            así como otras tecnologías incluyendo objetos de almacenamiento
            local tal como los HTML5. Estas tecnologías nos permiten manejar el
            acceso y uso de nuestros servicios, el cual reconoce y personaliza,
            y nos ayuda a entender como las personas utilizan los servicios de
            MEGA. No podrá acceder a ciertas áreas de nuestro sitio web,
            incluyendo mega.cl, si su computador no acepta las señaladas
            cookies. No respondemos a navegadores con señales de “Bloqueos de
            Seguimiento”. Si usted hace uso de los Servicios deberá desbloquear
            los “Bloqueos de Seguimiento”.
            </p>
          <p>
            Podremos transmitir información no-personal identificada en el sitio
            web a terceros para implementar anuncios para MEGA cuando visites
            otros sitios.
          </p>
          <h3>Objetos de Almacenamiento Local</h3>
          <p>
            MEGA podrá utilizar Objetos de Almacenamiento Local (LSOs) como
            HTML5 para almacenar el contenido de la información y sus
            preferencias. Terceros con quienes participemos en la entrega de
            determinadas acciones en nuestros sitios o para desplegar anuncios
            publicitarios basados en su comportamiento de navegación utilizan
            LSOs como HTML5 or Flash para colectar y almacenar información.
          </p>
          <h3>Analíticas, Archivos de registro e Historia de lectura.</h3>
          <p>
            Como en muchos sitios, recolectamos cierta información de manera
            automática y la almacenamos en archivos de registro. Esta
            información puede incluir direcciones de Protocolo de Internet (IP)
            (la región o acceso general en donde su computador o dispositivo
            obtiene acceso a internet), tipo de navegador, sistema operativo y
            otra información de uso relacionada con los servicios de MEGA,
            incluyendo historial de páginas que se visitan.
          </p>
          <p>
            Podremos combinar automáticamente información de log in colectada
            con otra información que colectemos con usted. Hacemos esto para
            mejorar los servicios que ofrecemos, incluyendo recomendaciones
            customizadas y publicidad, para mejorar marketing, y poder hacer
            seguimiento al uso y acceso de los servicios de MEGA a través de los
            diferentes dispositivos utilizados.
          </p>
          <p>
            MEGA ha contratado a terceros proveedores de información, reportes y
            análisis en cuanto al uso y patrones de navegación de usuarios.
            Ellos podrán independientemente registrar el tipo de
          </p>
          <p>
            dispositivo y sistema operativo que se está usando, información
            general de ubicación, así como los eventos que ocurran en nuestros
            sitios y/o aplicaciones, como la frecuencia de uso de estas.
          </p>
          <h3>
            Información de ubicación. Algunos de nuestros sitios y/o
            aplicaciones pueden entregar contenido basado en su ubicación
            actual.
          </h3>
          <p>
            Nuestros anuncios publicitarios pueden ser targetizados para usted
            en base a un código postal o direcciones de IP.
          </p>
          <h3>Terceros</h3>
          <p>
            Alguno de los Servicios y anuncios publicitarios incluidos en los
            Servicios, incluyendo mega.cl y nuestras aplicaciones móviles, son
            entregados o servidos por compañías de terceros, que pueden
            recolectar información en cuanto a su uso con los servicios de MEGA.
          </p>
          <p>
            Estas compañías pueden colocar o reconocer cookies, Web beacons u
            otras tecnologías para realizar seguimiento a cierta información
            no-personal de los usuarios de nuestros sitios web. Por ejemplo, en
            el curso de servir ciertos anuncios publicitarios, un anunciante
            podrá implantar o reconocer una cookie única en tu navegador para
            así recolectar cierta información de su uso con los servicios de
            MEGA. Un segundo ejemplo, un anunciante o servidor de anuncios
            también puede colectar información acerca de su dispositivo y su
            identificador único en el curso de servir el anuncio. En muchos
            casos, esta información podría ser utilizada para desplegar anuncios
            en otros sitios basados a sus intereses.
          </p>
          <p>
            Nosotros no tenemos accesos a, ni control sobre, este uso de las
            cookies por parte de terceros u otras tecnologías de seguimiento o
            de otra manera en la que pueden ser usados.
          </p>
          <h2>¿QUE HACEMOS CON LA INFORMACION QUE RECOLECTAMOS DE USTED?</h2>
          <h2>Entregarte los servicios que solicitas</h2>
          <p>
            Utilizamos la información que recolectamos de usted para habilitar
            su uso en los servicios de MEGA y completar los requerimientos de
            ciertos productos y servicios, como los es enviar newsletter
            electrónico, habilitando la participación en servicios pagados
            renovados, concursos y sorteos por mensaje.
          </p>
          <h3>Análisis de estadísticas</h3>
          <p>
            Desarrollamos análisis de estadísticas, demografía y marketing de
            los usuarios de los Servicios de MEGA y de sus patrones de
            suscripción y compra, con el propósito de desarrollo de productos y
            para informar con la naturalidad general de nuestra base de
            suscriptores. Utilizamos esta información para propósitos de
            análisis, incluyendo análisis para mejorar el servicio al cliente.
          </p>
          <h3>Customizando su experiencia</h3>
          <p>
            Utilizamos la información que recolectamos para permitirle a los
            anunciantes que puedan targetizar a sus usuarios y así permitirles
            entregarles u ofrecerles piezas más pertinentes. También, utilizamos
            esta información para customizar ciertas aplicaciones de los
            Servicios de MEGA para entregarle una mejor experiencia basada en el
            tipo de dispositivo que estás utilizando para acceder a los
            servicios de MEGA y, en ciertos casos, proveerle de servicios
            requeridos.
          </p>
          <h3>Anuncios publicitarios relevantes</h3>
          <p>
            MEGA podrá utilizar información demográfica y de preferencias para
            permitirle a los anunciantes que estén publicitando en los Servicios
            de MEGA llegar a los usuarios más pertinentes. Esto significa que
            los usuarios serán impactados por publicidad que tiene más
            probabilidades de interesarles, y los anunciantes entregar un
            mensaje a personas probablemente más receptivas, mejorando así la
            experiencia del usuario y la efectividad de los anuncios.
            Revelaremos toda la información a terceros sólo de manera y forma
            identificada.
          </p>
          <h3>Correos electronicos de Newsletters</h3>
          <p>
            MEGA periódicamente enviará correos electrónicos de newsletters o
            emails promocionales acerca de los servicios que ofrecemos y de sus
            anunciantes.
          </p>
          <h2>Con quién compartimos la información que colectamos MEGA:</h2>
          <p>
            Si usted se ha registrado en los Servicios de MEGA, no venderemos,
            cambiaremos, arrendaremos, o autorizaremos a ningún tercero para
            utilizar tu correo electrónico sin su permiso.
          </p>
          <p>
            En el futuro, podremos vender, comprar, o asociarnos con otras
            compañías o negocios. En dichas transacciones, podríamos incluir su
            información como parte de los activos transferidos.
          </p>
          <h3>Terceros:</h3>
          <p>
            También, compartimos información de nuestra audiencia de manera
            agregada y forma identificada. En esta política de privacidad es
            nuestra intención restringir el uso en cuanto compartir información
            agregada e identificada en todos los sentidos.
          </p>
          <p>
            Podremos compartir información de nuestros asistentes a eventos en
            vivo con sponsors u otros terceros. De ser así, notificaremos en
            cuanto se provea esta información.
          </p>
          <h3>Proveedores de servicio</h3>
          <p>
            Nosotros contratamos a otras compañías para proveer servicios de
            nuestra parte, incluyendo procedimientos de tarjetas de crédito y
            facturación, servidores de anuncios, despachos, distribución de
            correos electrónicos, procedimientos de lista, y analítica o
            administración de promociones.
          </p>
          <p>
            Nosotros proveemos a estas compañías solo con la información que
            ellos necesitan para realizar sus servicios. Estos proveedores de
            servicio están restringidos a usar información personal de cualquier
            manera que no sea para proveer servicios a MEGA y no deberán
            compartir, revender, o usar la información para sus propios
            propósitos de marketing.
          </p>
          <p>
            Nos reservamos el derecho a revelar su información de opción de
            salida a terceros para que ellos puedan gestionar su nombre en
            futuras solicitudes, de acuerdo con la ley aplicable.
          </p>
          <h2>¿CUAL ES NUESTRA POLITICA DE CORREOS ELECTRONICOS?</h2>
          <p>
              MEGA no enviará mensajes de marketing si has optado por salir.
              Usted puede escoger no recibir mensajes en el futuro si es que (1)
              sigue el proceso de “cancelación de suscripción” ubicada cercano
              el final de cada email, o (2) puede optar por salir aquí. No
              compartiremos, compraremos, venderemos, cambiaremos, o
              arrendaremos con terceros para que utilicen su correo electrónico
              para fines comerciales sin nuestro permiso. SI sientes que has
              recibido un email de parte nuestra por error, por favor contacta
            <a href="mailto:comunicaciones@mega.cl">comunicaciones@mega.cl</a>
          </p>
          <h3>Newsletters de correo electrónico.</h3>
          <p>
            MEGA ofrece diferentes newsletters. Si ya no desea recibir un
            newsletter especifico, sigue las instrucciones de “cancelación de
            suscripción” cercanas al final de cada newsletter.
          </p>
          <h3>Encuestas de correo electrónico.</h3>
          <p>
            Podremos invitarlo a participar en encuestas preguntando por
            retroalimentación de mega.cl y prospectos de productos y servicios,
            así como información para comprender de mejor manera a nuestros
            usuarios. Las encuestas a nuestros usuarios ayudan de gran manera a
            mejorar los servicios de MEGA y cualquier información que obtengamos
            en dichas encuestas no será compartida a terceros, excepto de manera
            agregada.
          </p>
          <h3>Correos electrónico de usted.</h3>
          <p>
            Si usted nos envía un correo electrónico, utilizaremos su correo
            para responder directamente a sus preguntas y comentarios.
          </p>
          <h3>Enviar por correo artículos u otros que desees compartir.</h3>
          <p>
            Las direcciones de correo que proveas en el “email” compartido podrá
            ser guardado para su conveniencia para futuros artículos u otros que
            desees enviar; pero no serán utilizados para otro propósito y no
            será compartido con terceros.
          </p>
          <h2>¿COMO ACTUALIZO O CAMBIO MI INFORMACION PERSONAL?</h2>
          <h2>El Home de recepción de su cuenta en la web de Mega. </h2>
          <p>
            Usted podrá actualizar y/o editar su información de cuenta online
            clickeando Actualizar Cuenta. En caso de requerir asistencia, por
            favor escríbanos a
            <a href="mailto:comunicaciones@mega.cl">comunicaciones@mega.cl</a>.
            Responderemos a todas las dudas relacionadas al manejo de dichos
            datos en un tiempo razonable.
          </p>
          <h3>Administrar su cuenta en Mega.cl en Mi Cuenta.</h3>
          <p>
            Usted podrá revisar y actualizar su membresía en Mega.cl e
            información de cuenta y acceder a su historial de transacciones en
            el área de Mi Cuenta. Responderemos a sus dudas relacionas con esta
            información en un tiempo razonable.
          </p>
          <h3>Retención de Información.</h3>
          <p>
            Nosotros retendremos su información por, al menos, el tiempo que
            cuenta esté activa; en la medida que se necesite proveer servicios;
            para cumplir con nuestras obligaciones legales; resolver disputas y
            cumplir nuestros acuerdos. Eliminaremos información personal
            identificable asociada con cuentas que hayan estado inactivas por al
            menos 15 años.
          </p>
          <h2>¿COMO OPTO POR SALIR?</h2>
          <p>
            Si en cualquier momento, prefiere no recibir información de
            marketing en su correo electrónico por parte nuestra, simplemente
            siga las opciones de “cancelación de suscripción” en el final de
            cada email.
          </p>
          <p>
            Si experimenta dificultades con el proceso de “cancelación de
            suscripción”, tenga la libertad de contactarnos a
            <a href="mailto:comunicaciones@mega.cl">comunicaciones@mega.cl</a> y
            provee su información de correo electrónico con el nombre del news
            letter del cual deseas desvincularte.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
